import { useState, useCallback } from "react";
import { refineQuestion } from "Services/demoService";
import logger from "utils/logger";

async function detectAndRefine(message, user_id, demo_id) {
  try {
    const res = await refineQuestion({ message, user_id, demo_id });
    const data = res?.data?.data;
    if (!data?.refined) return null;
    return data.refined;
  } catch (err) {
    logger.error('detectAndRefine failed:', err);
    return null;
  }
}

export function useQuestionBanner(isHost) {
  const [banners, setBanners] = useState([]);

  const handleChatMessage = useCallback(async ({ sender_name, message, user_id, urgent = false }) => {
    if (!isHost) return;

    const demoInfo = JSON.parse(localStorage.getItem('DETAILS'))?.sessionDetail;
    const id = Date.now();
    
    setBanners(prev => [...prev, {
      id, sender_name, message,
      refined: null,
      refining: true,
      urgent,
      timestamp: Date.now(),
    }]);
    
    const refined = await detectAndRefine(message, user_id, demoInfo?.id);

    if (refined === null) {
      setBanners(prev => prev.filter(b => b.id !== id));
      return;
    }
    
    setBanners(prev => prev.map(b => b.id === id ? {
      ...b, refined, refining: false,
    } : b));

  }, [isHost]);

  const dismiss = useCallback((id) => {
    setBanners(prev => prev.filter(b => b.id !== id));
  }, []);

  return { banners, handleChatMessage, dismiss };
}